import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Input, FormGroup, Label, Form, Row, Col, Card, CardBody, InputGroup, InputGroupText } from "reactstrap";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const EditClient = () => {
  const { id } = useParams(); // URL-la irundhu Client ID
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Form States
  const [formData, setFormData] = useState({
    id: id,
    name: "",
    email: "",
    phone: "",
    gstin: "",
    address: "",
    state_code: ""
  });

  const [errors, setErrors] = useState({});

  // 1. Existing Client Data-va fetch panna useEffect
  useEffect(() => {
    const fetchClientData = async () => {
      dispatch(loadingTrue());
      try {
        // Client view API (id moolama single client data edukkuradhukku)
        const res = await Handler({
          method: "GET",
          url: `/clients/view.php?id=${id}`
        });

        if (res?.success) {
          const client = res?.data?.client;
          setFormData({
            id: client.id,
            name: client.name,
            email: client.email || "",
            phone: client.phone,
            gstin: client.gstin || "",
            address: client.address || "",
            state_code: client.state_code || ""
          });
          dispatch(loadingFalse());
        } else {
          toast.error("Client not found!");
          navigate("/clients");
          dispatch(loadingFalse());
        }
      } catch (err) {
        toast.error("Error fetching client details");
      } finally {
        dispatch(loadingFalse());
      }
    };

    fetchClientData();
  }, [id, dispatch, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(loadingTrue());
    setErrors({});

    try {
      // Client update API path
      const res = await Handler({
        method: "POST", // Un PHP-la POST/PUT rendu allow pannirukka
        url: "/clients/update.php",
        data: formData
      });

      if (res?.success) {
        Swal.fire("Updated!", "Client details updated successfully", "success");
        navigate("/clients");
        dispatch(loadingFalse());
      } else {
        if (res?.errors) {
          setErrors(res.errors);
        } else {
          toast.error(res?.message || "Update failed");
        }
        dispatch(loadingFalse());
      }
    } catch (err) {
      Swal.fire("Error", "Server error occurred", "error");
    } finally {
      dispatch(loadingFalse());
    }
  };

  return (
    <div className="page-container p-1">
      <div className="page-header mb-4">
        <h6 className="text-muted">Management &gt; Clients</h6>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h3 className="fw-bold">Edit Client</h3>
            <p className="text-muted">Modify information for Client ID: <strong>#{id}</strong></p>
          </div>
          <Button color="secondary" outline onClick={() => navigate(-1)}>
            <i className="bx bx-arrow-back"></i> Back
          </Button>
        </div>
      </div>

      <Row>
        <Col lg={8}>
          <Card className="border-0 shadow-sm" style={{ borderRadius: '15px' }}>
            <CardBody className="p-4">
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={12} className="mb-3">
                    <FormGroup>
                      <Label className="fw-bold">Client / Company Name</Label>
                      <Input
                        type="text"
                        name="name"
                        placeholder="Enter name"
                        className={errors.name ? "is-invalid" : ""}
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label className="fw-bold">Phone Number</Label>
                      <InputGroup>
                        <InputGroupText><i className="bx bx-phone"></i></InputGroupText>
                        <Input
                          type="text"
                          name="phone"
                          placeholder="10 digit number"
                          maxLength="10"
                          className={errors.phone ? "is-invalid" : ""}
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </InputGroup>
                      {errors.phone && <div className="text-danger small mt-1">{errors.phone}</div>}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label className="fw-bold">Email Address</Label>
                      <Input
                        type="email"
                        name="email"
                        placeholder="client@example.com"
                        className={errors.email ? "is-invalid" : ""}
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </FormGroup>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col md={6}>
                    <FormGroup>
                      <Label className="fw-bold">GSTIN</Label>
                      <Input
                        type="text"
                        name="gstin"
                        placeholder="GST Number"
                        style={{ textTransform: 'uppercase' }}
                        value={formData.gstin}
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label className="fw-bold">State Code</Label>
                      <Input
                        type="text"
                        name="state_code"
                        placeholder="e.g. 33"
                        value={formData.state_code}
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <FormGroup className="mt-3">
                  <Label className="fw-bold">Address</Label>
                  <Input
                    type="textarea"
                    name="address"
                    placeholder="Enter full address"
                    rows="3"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </FormGroup>

                <div className="mt-4 pt-3 border-top d-flex justify-content-end">
                  <Button type="button" color="light" className="me-2" onClick={() => navigate(-1)}>
                    Cancel
                  </Button>
                  <Button type="submit" className="add-btn px-5">
                    <i className="bx bx-save me-1"></i> Save Changes
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>

        <Col lg={4}>
          <Card className="border-0 shadow-sm bg-theme text-white" style={{ borderRadius: '15px' }}>
            <CardBody className="p-4">
              <h5 className="fw-bold mb-3">Update Info</h5>
              <p className="small opacity-75">
                Client information update pannumbodhu Phone and Email duplicates irukka koodadhu. GSTIN format correct-ah check pannikonga machan.
              </p>
              <hr className="bg-white opacity-25" />
              <div className="small">
                <strong>Client ID:</strong> {id} <br />
                <strong>Status:</strong> Active
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default EditClient;